import {SelectEntityItem} from 'components/SelectEntityItem'
import _ from 'lodash'
import React from 'react'
import {notEmpty} from 'views/Shared'
import {profileSchema} from "../../../apis";

const ProfileEntity = ({item, children, defaultItem}) => (
  <SelectEntityItem
    item={item}
    defaultItem={defaultItem}
    schema={profileSchema}>
    {(data) => children(data)}
  </SelectEntityItem>
)

export const ProfileEntities = ({items, children, defaultItem}) => (
  <SelectEntityItem
    item={items}
    defaultItem={defaultItem}
    schema={[profileSchema]}>
    {(data = []) => children(_.filter(data, notEmpty))}
  </SelectEntityItem>
)

export default ProfileEntity
